import type { ComponentProps } from 'react';

import { cn } from '@repo/lib/cn';

export function Textarea(textareaProps: ComponentProps<'textarea'>) {
  const { className, ...props } = textareaProps;
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        'border-border-primary bg-input dark:bg-input/35 hover:bg-input-focus dark:hover:bg-input-focus/75 focus-visible:border-border-primary-focus focus-visible:outline-focus-ring aria-invalid:outline-ring-destructive dark:aria-invalid:outline-ring-destructive/50 aria-invalid:border-destructive/75 disabled:bg-input/60 rounded-md border px-4 py-2 text-base transition-colors outline-0 focus-visible:outline-3 aria-invalid:outline-3 md:text-sm placeholder:text-muted-foreground flex field-sizing-content min-h-16 w-full disabled:cursor-not-allowed disabled:opacity-60',
        className
      )}
      {...props}
    />
  );
}
